import React, { Component } from "react";
import { string, func } from "prop-types";

import { isMobile } from "../../logic/deviceType";

import "./style.css";

class LinkNativeCapture extends Component {
  static propTypes = {
    facingMode: string,
    onUploaded: func,
  };
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.onClick.bind(this);
    this.onUploaded.bind(this);
  }

  componentDidMount(){
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentWillUnmount(){
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  handleVisibilityChange = ()=>{
    if(typeof this.props.onVisibilityChange === "function"){
      this.props.onVisibilityChange(document.visibilityState === "visible");
    }
  }

  onClick = () => {
    this.props.handleShowNativeInstructions();
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.shouldStartNativeCamera !== nextProps.shouldStartNativeCamera
    ) {
      this.ref.current.value = "";
      this.ref.current.click();
    }
    return false;
  }

  onUploaded = (e) => {
    const files = e.target.files;
    if (files && files.length) {
      if (typeof this.props.onUploaded === "function") {
        this.props.onUploaded(files[0]);
      }
    }
  };

  render() {
    const buttonText = isMobile(navigator.userAgent)
      ? "Try native camera"
      : this.props.imageType === "selfie"
      ? "Upload selfie"
      : "Upload document";

    const className = this.props.class ? this.props.class : "button-link";

    return (
      <span>
        <input
          type="file"
          accept="image/*"
          capture={this.props.facingMode || "user"}
          ref={this.ref}
          onChange={this.onUploaded}
        />
        <button className={className} onClick={this.onClick}>
          {buttonText}
        </button>
      </span>
    );
  }
}

export default LinkNativeCapture;
